import * as React from "react";
import type { SVGProps } from "react";
const SvgBag05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.6 6.3H2.4h0m19.2 0v13.316c0 1.261-1.042 2.284-2.328 2.284H4.727c-1.285 0-2.327-1.023-2.327-2.284V6.3m19.2 0L17.751 2.45a1.2 1.2 0 0 0-.848-.351H7.097a1.2 1.2 0 0 0-.849.351L2.4 6.3m13.2 3.6a3.6 3.6 0 0 1-7.2 0"
    />
  </svg>
);
export default SvgBag05;
